import { Flex, useColorModeValue } from "@chakra-ui/react";
import CDS from "design-system";
import moment from "moment";
import { CalendarEvent } from "../types";
import EventsCard from "./EventsCard";

interface DayCellProps {
  day: moment.Moment;
  dateKey: string;
  isOutsideMonth: boolean;
  timezone: string;
  eventGroups: CalendarEvent[][];
  onEventClick?: (event: CalendarEvent) => void;
  isFirstInRow?: boolean;
  isLastInRow?: boolean;
  isLastRow?: boolean;
}

export default function DayCell({
  day,
  dateKey,
  isOutsideMonth,
  eventGroups,
  timezone,
  onEventClick = () => { },
  isFirstInRow = false,
  isLastInRow = false,
  isLastRow = false,
}: DayCellProps) {
  const bg = useColorModeValue("white", "gray.800");
  const muted = useColorModeValue("gray.300", "gray.600");

  return (
    <Flex
      direction="column"
      minHeight="140px"
      bg={bg}
      p="3"
      borderRight="1px solid"
      borderBottom="1px solid"
      borderColor="gray.200"
      position="relative"
      borderBottomLeftRadius={isLastRow && isFirstInRow ? "lg" : "none"}
      borderBottomRightRadius={isLastRow && isLastInRow ? "lg" : "none"}
    >
      {/* Day number */}
      <CDS.Text12
        color={isOutsideMonth ? muted : "gray.800"}
        fontWeight="medium"
        mb="2"
        lineHeight="1"
      >
        {day.date()}
      </CDS.Text12>

      {/* Events */}
      <Flex direction="column" gap="1" flex="1">
        {eventGroups.map((eventsByType, groupIndex) => (
          <EventsCard
            key={`${eventsByType[0]?.id ?? groupIndex}-${dateKey}`}
            eventsByType={eventsByType}
            timezone={timezone}
            handleClick={onEventClick}
          />
        ))}
      </Flex>
    </Flex>
  );
}
